export enum RequestStatus {
  Initial,
  Pending,
  Successful,
  Failed,
}
